export default "__VITE_ASSET__BbCsyVwF__"